<div class="popup" [ngClass]="{
       'popup--lock-screen': mode === 'lock-screen',
       'popup--time-clock': mode === 'time-clock'
     }">
  <div class="popup__header" [ngClass]="{
         'popup__header--clock-in': confirmStep && mode === 'time-clock' && clockAction === 'clockIn',
         'popup__header--clock-out': confirmStep && mode === 'time-clock' && clockAction === 'clockOut'
       }">
    <i class="material-icons popup__icon">{{ mode === 'time-clock' ? 'schedule' : 'lock' }}</i>
    <h2 class="popup__title" mat-dialog-title
        data-testid="popup-title">{{ confirmStep && mode === 'time-clock' ? confirmHeaderTitle : (confirmStep ? 'Confirm punch' : headerTitle) }}</h2>
    <p class="popup__subtitle">{{ confirmStep ? 'Review your status, then confirm to record the punch.' : headerSubtitle }}</p>
  </div>

  <!-- ===== Step 1: credential entry ===== -->
  <ng-container *ngIf="!confirmStep">
    <mat-dialog-content class="popup__content">
      <div class="popup__error" *ngIf="errorMessage">
        <i class="material-icons">error_outline</i>
        <span>{{errorMessage}}</span>
      </div>

      <div class="popup__field popup__field--select">
        <i class="material-icons popup__field-icon">person</i>
        <select class="popup__input"
                [(ngModel)]="selectedUsername"
                [disabled]="loading || isUsernameLocked || employees.length <= 1">
          <option *ngFor="let emp of employees" [value]="emp.username">
            {{ emp.displayName }}<ng-container *ngIf="emp.role"> &middot; {{emp.role}}</ng-container>
          </option>
        </select>
        <mat-spinner class="popup__field-spinner" *ngIf="loadingEmployees" diameter="16"></mat-spinner>
      </div>

      <div class="popup__field">
        <i class="material-icons popup__field-icon">vpn_key</i>
        <input class="popup__input"
               type="password"
               [placeholder]="credentialPlaceholder"
               [(ngModel)]="password"
               (keydown.enter)="submit()"
               [disabled]="loading"
               [attr.inputmode]="mode === 'time-clock' ? 'numeric' : 'text'"
               cdkFocusInitial/>
      </div>
    </mat-dialog-content>

    <div class="popup__actions">
      <button class="popup__btn popup__btn--cancel"
              *ngIf="mode !== 'lock-screen'"
              (click)="close()" [disabled]="loading">Cancel</button>
      <button class="popup__btn popup__btn--submit"
              [disabled]="loading || !password || !selectedUsername"
              (click)="submit()">
        <span *ngIf="!loading">{{ submitButtonLabel }}</span>
        <mat-spinner *ngIf="loading" diameter="20"></mat-spinner>
      </button>
    </div>
  </ng-container>

  <!-- ===== Step 2 (time-clock only): confirmation ===== -->
  <ng-container *ngIf="confirmStep">
    <mat-dialog-content class="popup__content popup__content--confirm">
      <div class="popup__error" *ngIf="errorMessage">
        <i class="material-icons">error_outline</i>
        <span>{{errorMessage}}</span>
      </div>

      <div class="popup__confirm-name">
        <i class="material-icons">person</i>
        <span>{{ previewName || selectedUsername }}</span>
      </div>

      <!-- Current state (what's true right now). -->
      <div class="popup__confirm-status"
           data-testid="confirm-current-state"
           [ngClass]="{'popup__confirm-status--on': previewOpenShift, 'popup__confirm-status--off': !previewOpenShift}">
        <ng-container *ngIf="previewOpenShift">
          <i class="material-icons">play_circle</i>
          <span>Currently on shift since {{ previewOpenShift.startedAt | date:'shortTime' }}</span>
        </ng-container>
        <ng-container *ngIf="!previewOpenShift">
          <i class="material-icons">pause_circle</i>
          <span>Currently not on shift</span>
        </ng-container>
      </div>

      <!-- Upcoming action (what the button below will do). Visually
           distinct from the current-state pill above so cashiers cannot
           confuse "you ARE on shift" with "you WILL be on shift". -->
      <div class="popup__confirm-action"
           data-testid="confirm-upcoming-action"
           [ngClass]="{'popup__confirm-action--clock-in': confirmActionBannerKind === 'clock-in',
                       'popup__confirm-action--clock-out': confirmActionBannerKind === 'clock-out'}">
        <i class="material-icons">{{ confirmActionBannerKind === 'clock-out' ? 'logout' : 'login' }}</i>
        <span>{{ confirmActionBannerText }}</span>
      </div>

      <!-- Intent-mismatch warning — only renders when preview decided the
           opposite action from what the cashier asked for via the menu. -->
      <div class="popup__confirm-warning"
           data-testid="confirm-intent-mismatch"
           *ngIf="actionFlippedByPreview">
        <i class="material-icons">warning_amber</i>
        <span>{{ intentMismatchWarning }}</span>
      </div>

      <div class="popup__confirm-history">
        <div class="popup__confirm-history-title">Today's punches</div>
        <ul *ngIf="previewEvents.length > 0">
          <li *ngFor="let ev of previewEvents">
            <span class="popup__confirm-history-time">{{ ev.occurredAt | date:'shortTime' }}</span>
            <span class="popup__confirm-history-type">{{ ev.type === 'CLOCK_IN' ? 'Clocked in' :
                                                          ev.type === 'CLOCK_OUT' ? 'Clocked out' :
                                                          ev.type === 'AUTO_CLOSE' ? 'Auto-closed' : ev.type }}</span>
          </li>
        </ul>
        <div class="popup__confirm-history-empty" *ngIf="previewEvents.length === 0">
          No punches yet today.
        </div>
      </div>
      <label class="popup__print-timesheet"
             *ngIf="hasReceiptPrinter && clockAction === 'clockOut'">
        <input type="checkbox" [(ngModel)]="printTimesheetOnClockout" />
        <i class="material-icons">receipt_long</i>
        <span>Print timesheet on clock out</span>
      </label>
    </mat-dialog-content>

    <div class="popup__actions">
      <button class="popup__btn popup__btn--cancel"
              (click)="cancelConfirm()" [disabled]="loading">Cancel</button>
      <button class="popup__btn popup__btn--submit"
              [ngClass]="{'popup__btn--clock-out-confirm': clockAction === 'clockOut'}"
              data-testid="confirm-punch-btn"
              [disabled]="loading"
              (click)="confirmPunch()">
        <span *ngIf="!loading">{{ clockAction === 'clockOut' ? 'Clock Out' : 'Clock In' }}</span>
        <mat-spinner *ngIf="loading" diameter="20"></mat-spinner>
      </button>
    </div>
  </ng-container>
</div>
